import { z } from 'zod';

export interface Invitation {
    id: number;

    creatorId: number;
    createdAt: Date;
    lastNotifiedAt: Date;

    email: string;
    farmId: number;
    roleId: number;
    status: string;
}

export const invitationSchema = z.object({
    id: z.number(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    lastNotifiedAt: z.coerce.date(),

    email: z.string(),
    farmId: z.number(),
    roleId: z.number(),
    status: z.string(),
});

export function mockInvitation({
    id = 0,

    creatorId = 0,
    createdAt = new Date(),
    lastNotifiedAt = new Date(),

    email = 'user@email.com',
    farmId = 0,
    roleId = 0,
    status = 'Pending',
}: Partial<Invitation> = {}): Invitation {
    return {
        id,

        creatorId,
        createdAt,
        lastNotifiedAt,

        email,
        farmId,
        roleId,
        status,
    };
}
